import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'shorten'
  })
  export class ShortenPipe implements PipeTransform {
    transform(val:string , length?: any):string {
      return (val && val.length > length )? val.slice(0, length)+'...':val;
    }
  }


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/pipes/shorten.pipe.ts